import type { ComponentProps, ReactNode } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import formatOfferInclusionDescription from 'lib/offer/formatOfferInclusionDescription'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'
import CruiseFlightCreditInfo from './CruiseFlightCreditInfo'

interface Props {
  size?: ComponentProps<typeof BodyTextBlock>['variant']
  lineClamp?: ComponentProps<typeof BodyTextBlock>['lineClamp']
  inclusion: App.PackageInclusion
  showMinStayDescription?: boolean
  showMoreLink?: ReactNode
  endIcon?: ReactNode
}

function CruiseOfferInclusionItem({ size = 'medium', lineClamp, inclusion, showMinStayDescription, showMoreLink, endIcon }: Props) {
  const intl = useIntl()
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion.symbol])
  const inclusionDescription = useMemo(() => {
    return formatOfferInclusionDescription(inclusion.description, intl)
  }, [inclusion.description, intl])
  const minStayDescription = showMinStayDescription ? getInclusionMinStayText(inclusion, intl) : undefined
  const hasFlightCredit = inclusion.categories?.includes('FLIGHT_CREDIT')

  return <BodyTextBlock
    variant={size}
    lineClamp={lineClamp}
    endIcon={lineClamp && (hasFlightCredit || endIcon) ? <>
      {hasFlightCredit && <CruiseFlightCreditInfo />}
      {endIcon}
    </> : undefined}
    colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
    weight={inclusion.isHighlighted ? 'bold' : 'normal'}
    startIcon={<Icon
      colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
      data-symbol={inclusion.symbol}
    />}
  >
    {inclusionDescription} {!lineClamp && hasFlightCredit && <CruiseFlightCreditInfo />} {minStayDescription}
    {!!showMoreLink && <> {showMoreLink}</>} {!lineClamp && !!endIcon && <> {endIcon}</>}
  </BodyTextBlock>
}

export default CruiseOfferInclusionItem
